import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const buttonList = store.getters && store.getters.buttonList
    if (value && value.length > 0) {
      const hasPermission = (buttonList.indexOf(value) !== -1)
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`使用方式： v-permissionButton="'permission'"`)
    }
  }
}
